import { render } from "./ManualForm.vue?vue&type=template&id=212c68a7&scoped=true"
import script from "./ManualForm.vue?vue&type=script&lang=js"
export * from "./ManualForm.vue?vue&type=script&lang=js"

import "./ManualForm.vue?vue&type=style&index=0&id=212c68a7&lang=css"
import "./ManualForm.vue?vue&type=style&index=1&id=212c68a7&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-212c68a7"]])

export default __exports__